<template>
	<div id="front-page" class="container mx-auto py-12 px-6">
		<BoxLinks title="Hjálpartæki markaðslífsins" :items="features"/>
		<BoxLinks title="Kerfin okkar" :items="references"/>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import BoxLinks from '@@/blocks/BoxLinks.vue'

export default defineComponent({
  name: 'FrontPage',

	components: {
		BoxLinks
	},

	data () {
		return {
			references: [
				{ title: 'Gygax', subtitle: 'Bakendinn fyrir ÚÚ o.fl.', url: 'https://gygax.fitravel.info', image: '/gygax.png' },
				{ title: 'SF Umbraco', subtitle: 'Bakendinn fyrir SF', url: 'https://sumarferdir.is/umbraco', image: '/umbraco-sf.png' },
				{ title: 'PF Umbraco', subtitle: 'Bakendinn fyrir PF', url: 'https://plusferdir.is/umbraco', image: '/umbraco-pf.png' },
				{ title: 'Mailchimp', subtitle: 'Fyrir markpósta', url: 'https://mailchimp.com', image: '/mailchimp.jpg' },
				{ title: 'TRIP Sandbox', subtitle: 'Fyrir Trip kóða', url: 'https://trip.eiginvegum.uu.is/dynapack/clients/bitusi/public/trip-cms/', image: '/' },
				{ title: 'TRIP Admin', subtitle: 'Fyrir Trip ', url: '', image:'/' },
				{ title: 'Odin / Corivo', subtitle: 'Fyrir lagerinn', url: 'https://fitravel.odinsystem.net', image: '/' },
				{ title: 'Odin', subtitle: 'Fyrir lagerinn', url: 'https://fitravel.odinsystem.net', image: '/' },
				{ title: 'Irix', subtitle: 'Fyrir DCS', url: 'https://irix.fitravel.info', image: '/' },
				{ title: 'Tina', subtitle: 'Fyrir DCS bókhald', url: 'https://tina.fitravel.info', image: '/' }
			],
			features: [
				{ title: 'TRIP chimplate', subtitle: '', url: '/tripchimp', image: '' }
			]
		}
	},

	setup () {
		
	}
})
</script>